// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.midoin",
    name: "midoin",
    homepage: "https://midoin.com",
    image_id: "9728246c-9504-4b0f-9881-ed848c9fa000",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/midoin/id1374974523",
        android: "https://play.google.com/store/apps/details?id=com.midoin",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "midoin://",
        universal: "https://midoin.app.link",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map